module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Push Notification")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Push Notification")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary-outline",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#demo"
    }
  }, [_vm._v("\n                List Push Notif\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', _vm._l((_vm.headers), function(item, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.listPush), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.channel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("convertDate")(item.scheduled_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("convertDate")(item.created_at)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.pagination.current_page === 1
    },
    on: {
      "click": function($event) {
        return _vm.paging(-1)
      }
    }
  }, [_vm._v("\n                    Previous\n                  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px",
      "font-size": "18px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.pagination.current_page + '/' + _vm.pagination.total_page) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.pagination.current_page === _vm.pagination.total_page
    },
    on: {
      "click": function($event) {
        return _vm.paging(1)
      }
    }
  }, [_vm._v("\n                    Next\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                " + _vm._s(message) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mode Notifikasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputMode),
      expression: "inputMode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inputMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Notifikasi Umum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Notifikasi Dengan Konten")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Jadwalkan Push Notif")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduledDate),
      expression: "scheduledDate"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "scheduledDate",
      "type": "text",
      "placeholder": "Tanggal Notif akan dipush",
      "name": "scheduled_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.scheduledDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduledDate = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduledTime),
      expression: "scheduledTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "scheduledTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "scheduled_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.scheduledTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduledTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('title') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('text') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pesan")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.text),
      expression: "form.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "130",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.form.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('imageurl') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.imageurl),
      expression: "form.imageurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.imageurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "imageurl", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('content') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "130",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Link (opsional)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('cta') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Call to Action")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cta),
      expression: "form.cta"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.cta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cta", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextButton()
      }
    }
  }, [_vm._v("\n                Selanjutnya\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "konfirmpushnotif",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.modeDialogForm == '1') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            FCM Token\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fcmtoken),
      expression: "fcmtoken"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fcmtoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fcmtoken = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.submitNotification('test')
      }
    }
  }, [_vm._v("\n                Kirim Test\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.submitNotification('all')
      }
    }
  }, [_vm._v("\n                Kirim Semua\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modeDialogForm == '2') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Data testing berhasil terkirim")]), _vm._v(" "), _c('p', [_vm._v("Harap periksa apakah notifikasi sudah berhasil diterima")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n                Edit Pesan\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.submitNotification('all')
      }
    }
  }, [_vm._v("\n                Kirim Semua\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modeDialogForm == '3') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Data berhasil terkirim ke seluruh user")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n                OK\n              ")])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Push Notif")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db48bc2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/push_notif/PushNotif.vue
// module id = 1398
// module chunks = 0